import post from "../../../post";
import Message from "../../../../entities/Message";

export const seen = (message: Message) =>
    post(`messages/${message.id}/seen`, {});